import React from "react";
import Layout from "../components/common/Layout";

const ImpactProgram = () => {
    return (

        < Layout>
            <section className="relative min-h-screen text-white overflow-hidden">

                {/* Contenido central */}
                <div className="relative z-10 flex items-center justify-center min-h-screen px-6 py-20 backdrop-blur-md">
                    <div className="bg-white/90 dark:bg-[#112626]/90 rounded-xl shadow-xl p-10 max-w-4xl text-gray-800 dark:text-gray-100 text-justify">

                        <h1 className="text-3xl font-bold mb-6 text-center text-primary dark:text-lightGreen">🌍 Slowork

                            <span className="text-[#E0BB44] font-semibold"> Impact Program 🌍 </span>
                        </h1>
                        <p className="text-center mb-8">
                            Empowering sustainable Remote Work Communities around the world
                        </p>

                        <p className="mb-4">
                            <strong>Make your space remote-work ready — and make a difference.</strong> The Slowork Impact Program is designed to support digital nomads, remote workers, and eco-conscious travelers by improving access to high-quality coworking and coliving spaces in underdeveloped or rural areas.
                        </p>

                        <p className="mb-4">
                            We reinvest up to <span className="text-[#E0BB44] font-semibold"> 2% of every transaction</span> made through the Slowork platform into selected projects:
                        </p>

                        <ul className="list-disc pl-6 mb-4">
                            <li>1% is allocated by Slowork to projects aligned with our mission of sustainable and responsible travel.</li>
                            <li>1% is chosen by the community, allowing digital nomads and remote professionals to vote on which spaces and regions they want to support.</li>
                        </ul>

                        <h2 className="text-2xl font-semibold mt-6 mb-2">Boost Visibility & Funding for Your Project</h2>
                        <p className="mb-4">
                            Once accepted into the Slowork Impact Program, your project becomes eligible for additional crowdfunding exposure. We’ll publish your listing on our Crowdfunding for Remote Work page, where our global community and third-party donors can directly contribute.
                        </p>

                        <ul className="space-y-4 mb-4">
                            <li className="flex items-start gap-3">
                                <span className="text-xl mt-1 flex-shrink-0">📢</span>
                                <p className="text-justify">
                                    <strong>Attract more visibility</strong> among the growing community of remote workers and location-independent entrepreneurs.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="text-xl mt-1 flex-shrink-0">💰</span>
                                <p className="text-justify">
                                    <strong>Secure alternative funding</strong> for improving internet connectivity, eco-friendly infrastructure, and wellness-focused amenities.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="text-xl mt-1 flex-shrink-0">🌐</span>
                                <p className="text-justify">
                                    <strong>Become part of a global network</strong> of digital nomad-friendly destinations.
                                </p>
                            </li>
                        </ul>

                        <h2 className="text-2xl font-semibold mt-6 mb-2">Why Join the Impact Program?</h2>
                        <ul className="space-y-4 mb-4">
                            <li className="flex items-start gap-3">
                                <span className="text-xl mt-1 flex-shrink-0">🎯</span>
                                <p className="text-justify">
                                    <strong>Get certified:</strong> Earn the Slowork Certification for meeting essential remote work and sustainability standards.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="text-xl mt-1 flex-shrink-0">🌱</span>
                                <p className="text-justify">
                                    <strong>Receive funding:</strong> Tap into platform donations and community-led crowdfunding.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="text-xl mt-1 flex-shrink-0">🔗</span>
                                <p className="text-justify">
                                    <strong>Gain visibility:</strong> Be featured in our marketing campaigns and global map of remote work-friendly destinations.
                                </p>
                            </li>

                            <li className="flex items-start gap-3">
                                <span className="text-xl mt-1 flex-shrink-0">🤝</span>
                                <p className="text-justify">
                                    <strong>Join a movement:</strong> Become part of a purpose-driven global ecosystem that values slow travel, conscious living, and professional flexibility.
                                </p>
                            </li>
                        </ul>


                    </div>
                </div>
            </section>

        </Layout>
    );
};

export default ImpactProgram;
